<div>
  <div class="row row-flex row-template" [nbSpinner]="loading">
    <div class="col-template-left" [ngClass]="isOpened ? '':'hidden-center'">
      <div class="template-left">
        <div class="chek-template">
          <label class="form-label">Выбранный шаблон</label> <label *ngIf="selectedTemplate">#{{ selectedTemplate.id }}</label>
        </div>
        <div class="template-left__name">
          <ng-select [items]="templates$ | async" bindLabel="header" bindValue="id" [minTermLength]="2" [compareWith]="compareTemplates" [loading]="loadingTemplates" [typeahead]="templateInput$" [clearable]="false" (change)="changeSelectedTemplate($event)" [(ngModel)]="selectedTemplate" typeToSearchText="Пожалуйста, введите 2 или более символов" i18n-typeToSearchText="@@TemplateAutocompleteTypeToSearchText" placeholder="Введите название шаблона" i18n-placeholder="@@TemplateAutocompleteLabel"></ng-select>
        </div>
        <div class="last-changes">
          <p>Последние изменения <span *ngIf="model.updatedAt">{{ model.updatedAt | date: 'dd.MM.yyyy HH:mm:ss' }}</span></p>
        </div>

        <nb-accordion multi class="template-left__properties" *ngIf="bindedTemplate && bindedTemplate.groups">
          <nb-accordion-item *ngFor="let fieldsGroup of bindedTemplate.groups; let groupIndex = index;" #groupItem id="groupItem_{{groupIndex}}" [expanded]="true">
            <nb-accordion-item-header id="glava1" name="glava1">
              {{ fieldsGroup.header }}

              <ng-container *ngIf="isGroupFilled(fieldsGroup.id)">
                <span class="state-success">{{ allFeaturesInGroup(fieldsGroup.id) }} из {{ allFeaturesInGroup(fieldsGroup.id) }}
                  <nb-icon icon="checkmark-outline"/></span>
              </ng-container>

              <ng-container *ngIf="isGroupNotFilled(fieldsGroup.id)">
                <span class="state-warn">{{ emptyFeaturesInGroup(fieldsGroup.id) }} из {{ allFeaturesInGroup(fieldsGroup.id) }}
                  <nb-icon icon="alert-triangle-outline"/></span>
              </ng-container>

              <a name="glava1" [routerLink]="['/cabinet/pim/feature-group/edit/', fieldsGroup.groupId]" target="_blank" class="entityID" i18n-nbTooltip="@@OpenFeatureGroupInNewWindow" nbTooltip="Открыть группу в новом окне"> #{{ fieldsGroup.groupId }} </a>
            </nb-accordion-item-header>
            <nb-accordion-item-body>
              <ng-container *ngFor="let feature of fieldsGroup.features">
                <app-tf-select *ngIf="isSelectableFeatureType(feature.featureTypeId)" [feature]="feature" [featureLink]="true" class="accordion-item"/>
                <app-tf-range *ngIf="isRangeFeatureType(feature.featureTypeId)" [feature]="feature" [featureLink]="true" class="accordion-item"/>
                <app-tf-boolean *ngIf="isBooleanFeatureType(feature.featureTypeId)" [feature]="feature" [featureLink]="true" class="accordion-item"/>
                <app-tf-interval *ngIf="isIntervalFeatureType(feature.featureTypeId)" [feature]="feature" [featureLink]="true" class="accordion-item"/>
                <app-tf-string *ngIf="isStringFeatureType(feature.featureTypeId)" [feature]="feature" [featureLink]="true" class="accordion-item"/>
                <app-tf-html *ngIf="isHtmlFeatureType(feature.featureTypeId)" [feature]="feature" [featureLink]="true" class="accordion-item"/>
                <app-tf-size *ngIf="isSizeFeatureType(feature.featureTypeId)" [feature]="feature" [featureLink]="true" class="accordion-item"/>
                <app-tf-link *ngIf="isLinkFeatureType(feature.featureTypeId)" [feature]="feature" [featureLink]="true" class="accordion-item"/>
                <app-tf-smartlist *ngIf="isSmartlistFeatureType(feature.featureTypeId)" [feature]="feature" [featureLink]="true" class="accordion-item"/>
              </ng-container>
            </nb-accordion-item-body>
          </nb-accordion-item>
        </nb-accordion>
        <br><br><br><br>


        <div class="submit-button">
          <button nbButton status="primary" type="button" [disabled]="!productFeatureStatus || productFeatureStatus.error || !modelFeaturesChanges" (click)="saveFeatureModel()" i18n="@@Save">
            Сохранить изменения
          </button>

          <button (click)="back()" nbButton status="basic" type="button" i18n>Отмена</button>

          <ng-container *ngIf="productFeatureStatus && productFeatureStatus.empty">
            <nb-icon icon="alert-triangle-outline" status="warning"/>
            {{ productFeatureStatus.empty }} не заполненных полей
          </ng-container>
        </div>
      </div>
    </div>
    <div class="template-features__wrap" [ngClass]="isOpened ? '':'hidden-center'">
      <button nbButton status="control" class="close-nav" type="button" (click)="toggleOpened()" nbTooltip="{{ isOpened ? 'Скрыть колонку':'Показать колонку' }}">
        <nb-icon icon="menu-arrow-outline"></nb-icon>
      </button>

      <div class="template-right template-right__scroll" *ngIf="isOpened">
        <div class="template-right__top">
          <h6 *ngIf="selectedTemplate">
            <a [routerLink]="['/cabinet/pim/template-group/item/edit', selectedTemplate.id]" target="_blank" style="text-decoration: none">
              {{ selectedTemplate.header }}
              <nb-icon icon="external-link-outline"/>
            </a>
          </h6>

          <div class="productCopyForm">
            <form [formGroup]="baseProductIdForm" (ngSubmit)="copyFeatureValues()">
              <nb-form-field>
                <input type="text" formControlName="productId" nbInput fieldSize="small" placeholder="Введите ID товара для копирования">
                <button nbSuffix ghost nbButton size="small" type="submit" *ngIf="!baseProductIdForm.invalid">
                  <nb-icon icon="copy-outline"/>
                </button>
              </nb-form-field>
            </form>
          </div>
        </div>
        <div class="template-right__content" *ngIf="bindedTemplate">
          <!--          <a  class="template-right__content-item pointer" [class.item-respect]="isGroupNotFilled(group.id)"-->
          <!--               *ngFor="let group of bindedTemplate.groups; let groupIndex = index;" (click)="scrollToGroup(groupIndex)">-->
          <a (click)="scrollToGroup(groupIndex)" class="template-right__content-item pointer" *ngFor="let group of bindedTemplate.groups; let groupIndex = index;"> {{ group.header }}<span *ngIf="isGroupNotFilled(group.id)"> <nb-icon icon="alert-triangle-outline" status="warning"/>
            {{ emptyFeaturesInGroup(group.id) }} из {{ allFeaturesInGroup(group.id) }}</span> </a>
        </div>
      </div>

    </div>
  </div>
</div>
